export const BisheObjectMaterial = `query BisheObjectMaterial{
  bisheObjectMaterials(sort: "id" ) {
    title
    cont
    url
  }
}`